import { useEffect, useState } from 'react'
import icon1 from '../../../public/images/main-page/icon/date-2@3x-8 1.png'
import icon2 from '../../../public/images/main-page/icon/3@4x-8.png'
import icon3 from '../../../public/images/main-page/icon/2@4x-8.png'
import icon4 from '../../../public/images/main-page/icon/1@4x-8.png'
import Image from 'next/image'
import { getStockPrice } from 'data/fetchPlugin'
import moment from 'moment'
import styles from './StockPrice.module.scss'

const StockPrice = () => {
    const [price, setPrice] = useState({})
    useEffect(() => {
        (async () => {
            const date_default = moment()
            const item = {
                regularMarketChange: Number(0).toFixed(2),
                regularMarketPrice: Number(0).toFixed(2),
                date: `${date_default.format('DD')}/${date_default.format('MM')}/${date_default.format('YYYY').toString().substr(-2)}`
            }
            let data = await getStockPrice()
            let date = moment(data?.regularMarketTime)
            let year = date.format('YYYY').toString().substr(-2)
            let month = date.format('MM')
            let day = date.format('DD')
            item.regularMarketChange = Number(data?.regularMarketChange || 0).toFixed(2)
            item.regularMarketPrice = Number(data?.regularMarketPrice || 0).toFixed(2)
            item.date = `${day}/${month}/${year}`
            setPrice(item)
        })()
    }, [])

    return (
        <div className={styles.stockWrap}>
            <div className={styles.stockItem}>
                <Image 
                    width={45}
                    height={49}
                    placeholder={'blur'}
                    src={icon1}
                    alt={'icon1'}
                />
                <p className={styles.textMain}>{price?.date}</p>
                <p className={styles.textSecond}>
                    <small>
                        Update Date
                    </small>
                </p>
            </div>
            <div className={styles.stockItem}>
                <Image 
                    width={50}
                    height={49}
                    placeholder={'blur'}
                    src={icon2}
                    alt={'icon1'}
                />
                <p className={styles.textMain}>JTS</p>
                <p className={styles.textSecond}>
                    <small>
                        Stock Name
                    </small>
                </p>
            </div>
            <div className={styles.stockItem}>
                <Image 
                    width={80}
                    height={45}
                    placeholder={'blur'}
                    src={icon3}
                    alt={'icon1'}
                />
                <p className={styles.textMain}>{price?.regularMarketPrice || '-'}</p>
                <p className={styles.textSecond}>
                    <small>
                        Last Price
                    </small>
                </p>
            </div>
            <div className={styles.stockItem}>
                <Image 
                    width={61}
                    height={57}
                    placeholder={'blur'}
                    src={icon4}
                    alt={'icon1'}
                />
                <p className={styles.textMain}>{price?.regularMarketChange ? `${price?.regularMarketChange < 0 ? '' : '+'}${price?.regularMarketChange}` : '-'}</p>
                <p className={styles.textSecond}>
                    <small>
                        Change
                    </small>
                </p>
            </div>
        </div>
    )
}

export default StockPrice